import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { values } from 'lodash-es';
import { Observable } from 'rxjs';
import { EnvService } from '..';

@Injectable({ providedIn: 'root' })
export class OptionalFeatureRouteGuardService implements CanActivate {
  constructor(private envService: EnvService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const disabledRouteFeature = values(this.envService.features).find(
      (feature) => !feature.enabled && feature.route && state.url?.toLowerCase() === feature.route.toLowerCase()
    );

    if (disabledRouteFeature) {
      this.router.navigate([disabledRouteFeature.redirectionRoute || '']);
      return false;
    }

    return true;
  }
}
